import { TextButton } from '@buoyhealth/common.buoy-button';

function SubmittedView({
  descriptionText,
  email,
  onEdit,
}: {
  descriptionText?: string;
  email: string;
  onEdit: any;
}) {
  return (
    <div className="bp-w-full bp-font-primary bp-text-sm bp-font-normal bp-leading-secondary">
      {descriptionText}:{' '}
      <span>
        {email}
        <TextButton onClick={onEdit} className="bp-ml-2 !bp-text-sm bp-underline">
          Edit
        </TextButton>
      </span>
    </div>
  );
}

export default SubmittedView;
